"use client";

import React, { useMemo, useState, useEffect } from "react";
import { Form, Row, Col, CardBody, Button, Toast, ToastContainer, Modal } from "react-bootstrap";
import NavList from "../NavList";
import { useUserStore } from "../../../store/user-store";
import { useDataFetch } from "../../../hooks/use-data-fetch";

type AccountType = 1 | 2 | 3 | 4 | 5;

type Bank = {
  id: string;
  name: string;
  transfiya: boolean;
  isWallet?: boolean;
};

type IdentificationType = "CC" | "CE" | "NIT" | "PASSPORT" | "PPT";


const IDENTIFICATION_TYPES = [
  { id: "CC", label: "Cédula de Ciudadanía" },
  { id: "CE", label: "Cédula de Extranjería" },
  { id: "NIT", label: "NIT" },
  { id: "PASSPORT", label: "Pasaporte" },
  { id: "PPT", label: "Permiso por protección temporal" }
];

const ACCOUNT_TYPES = [
  { id: 1, label: "Cuenta Corriente" },
  { id: 2, label: "Cuenta de Ahorros" },
  { id: 3, label: "Efectivo", disabled: true },
  { id: 4, label: "Número de Celular" },
  { id: 5, label: "Bre-B", disabled: true },
];

export const BANKS: Bank[] = [
  { id: "001", name: "BANCO DE BOGOTÁ", transfiya: false },
  { id: "002", name: "BANCO POPULAR", transfiya: true },
  { id: "006", name: "ITAÚ", transfiya: true },
  { id: "007", name: "BANCOLOMBIA", transfiya: true },
  { id: "009", name: "CITIBANK", transfiya: false },
  { id: "012", name: "BANCO GNB SUDAMERIS", transfiya: false },
  { id: "013", name: "BBVA COLOMBIA", transfiya: false },
  { id: "019", name: "SCOTIABANK COLPATRIA S.A.", transfiya: false },
  { id: "023", name: "BANCO DE OCCIDENTE", transfiya: false },
  { id: "031", name: "BANCOLDEX S.A.", transfiya: false },
  { id: "032", name: "BANCO CAJA SOCIAL BCSC S.A.", transfiya: false },
  { id: "040", name: "BANCO AGRARIO", transfiya: true },
  { id: "042", name: "BNP PARIBAS COLOMBIA", transfiya: false },
  { id: "047", name: "BANCO MUNDO MUJER", transfiya: false },
  { id: "051", name: "BANCO DAVIVIENDA S.A.", transfiya: true },
  { id: "052", name: "BANCO AV VILLAS", transfiya: false },
  { id: "053", name: "BANCO W S.A.", transfiya: false },
  { id: "058", name: "BANCO PROCREDIT COLOMBIA", transfiya: false },
  { id: "059", name: "BANCAMIA S.A.", transfiya: true },
  { id: "060", name: "BANCO PICHINCHA", transfiya: false },
  { id: "061", name: "BANCOOMEVA", transfiya: true },
  { id: "062", name: "BANCO FALABELLA S.A.", transfiya: true },
  { id: "063", name: "BANCO FINANDINA S.A.", transfiya: true },
  { id: "064", name: "BANCO MULTIBANK S.A.", transfiya: false },
  { id: "065", name: "BANCO SANTANDER DE NEGOCIOS COLOMBIA S.A.", transfiya: false },
  { id: "066", name: "BANCO COOPERATIVO COOPCENTRAL", transfiya: true },
  { id: "067", name: "BANCO COMPARTIR S.A.", transfiya: false },
  { id: "069", name: "BANCO SERFINANZA S.A.", transfiya: true },
  { id: "070", name: "LULO BANK", transfiya: false },
  { id: "071", name: "BANCO JP MORGAN COLOMBIA", transfiya: false },
  { id: "083", name: "COMPENSAR", transfiya: false },
  { id: "084", name: "APORTES EN LINEA", transfiya: false },
  { id: "086", name: "ASOPAGOS", transfiya: false },
  { id: "087", name: "FEDECAJAS", transfiya: false },
  { id: "088", name: "SIMPLE", transfiya: false },
  { id: "089", name: "ENLACE OPERATIVO", transfiya: false },
  { id: "090", name: "CORFICOLOMBIANA", transfiya: false },
  { id: "121", name: "FINANCIERA JURISCOOP S.A.", transfiya: false },
  { id: "283", name: "COOPERATIVA FINANCIERA DE ANTIOQUIA", transfiya: true },
  { id: "289", name: "COOTRAFA COOPERATIVA FINANCIERA", transfiya: false },
  { id: "292", name: "CONFIAR", transfiya: true },
  { id: "303", name: "Banco Unión (GIROS Y FINANZAS)", transfiya: false },
  { id: "342", name: "SERVIFINANSA S.A.", transfiya: false },
  { id: "370", name: "COLTEFINANCIERA S.A.", transfiya: false },
  { id: "507", name: "NEQUI", transfiya: true, isWallet: true },
  { id: "550", name: "DECEVAL", transfiya: false },
  { id: "551", name: "DAVIPLATA", transfiya: true, isWallet: true },
  { id: "560", name: "PIBANK", transfiya: false },
  { id: "637", name: "IRIS", transfiya: false },
  { id: "683", name: "DIRECCIÓN DEL TESORO NACIONAL", transfiya: false },
  { id: "685", name: "DGCPTN SISTEMA GENERAL DE REGALIAS", transfiya: false },
  { id: "801", name: "MOVII", transfiya: true },
  { id: "803", name: "POWWI", transfiya: true },
  { id: "805", name: "BANCO BTG PACTUAL", transfiya: false },
  { id: "808", name: "Bold CF", transfiya: true },
  { id: "812", name: "COINK", transfiya: false },
  { id: "809", name: "NU", transfiya: false },
  { id: "814", name: "Global66", transfiya: false },
  { id: "819", name: "Banco Contactar", transfiya: false },
  { id: "1053", name: "BANCO WWB", transfiya: false },
  { id: "1291", name: "COOFINEP", transfiya: false },
  { id: "1558", name: "Ban100 (CREDIFINANCIERA SA)", transfiya: false },
  { id: "1559", name: "DING TECNIPAGOS", transfiya: false },
  { id: "1560", name: "UALA", transfiya: false },
  { id: "1561", name: "RAPPIPAY", transfiya: false },
  { id: "820", name: "Superdigital", transfiya: false },
  { id: "821", name: "Banco Cooperativo Coopcentral Digital", transfiya: false },
  { id: "822", name: "Dale", transfiya: false },
  { id: "823", name: "Banco Crezcamos", transfiya: false }
];

function resolveBanks(accountType: AccountType | null) {
  if (!accountType) return [];
  if (accountType === 4) return BANKS.filter(b => b.isWallet);
  return BANKS.filter(b => !b.isWallet); 
}

const onlyNumbers = /^[0-9]+$/;

export default function AccountBankSettingsForm() {
  const user = useUserStore(state => state.user);
  const setUser = useUserStore(state => state.setUser);

  const { patchData } = useDataFetch();
  const { mutateAsync: updateUser, isPending } = patchData("/users/update/user", {});

  const [accountHolderName, setAccountHolderName] = useState("");
  const [identificationType, setIdentificationType] = useState<IdentificationType | "">("");

  const [identificationNumber, setIdentificationNumber] = useState("");
  const [accountType, setAccountType] = useState<AccountType | null>(null);
  const [bankId, setBankId] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState<"success" | "danger">("success");

  /** Prefill desde el usuario */
  useEffect(() => {
    if (user?.bankAccount) {
      setAccountType(user.bankAccount.accountType as AccountType);
      setBankId(user.bankAccount.bankCode || "");
      setAccountNumber(user.bankAccount.accountNumber || "");

      setAccountHolderName(user.bankAccount.accountHolderName || "");
      setIdentificationType(user.bankAccount.identificationType || "");
      setIdentificationNumber(user.bankAccount.identificationNumber || "");
      setAcceptedTerms(user.bankAccount.acceptedTerms ?? false);
    }
  }, [user]);

  const banks = useMemo(() => resolveBanks(accountType), [accountType]);
  const bank = banks.find(b => b.id === bankId);
  const isPhoneAccount = accountType === 4 || bank?.isWallet;

  const isAccountTypeInvalid = submitted && !accountType;
  const isBankInvalid = submitted && !bankId;

  const isAccountNumberInvalid =
  submitted &&
  (!accountNumber || !onlyNumbers.test(accountNumber));

  const onSubmit = async (e: React.FormEvent) => {
    setShowTermsModal(true)
    e.preventDefault();
    setSubmitted(true);

    if (
      !accountType ||
      !bankId ||
      !accountNumber ||
      !accountHolderName ||
      !identificationType ||
      !identificationNumber ||
      !acceptedTerms || 
      !user
    ) return;

    const body = {
      bankAccount: {
        accountHolderName,
        identificationType,
        identificationNumber,
        accountType,
        bankCode: bankId,
        accountNumber,
        acceptedTerms
      },
    };

    try {
      await updateUser(body);

      setUser({
        ...user,
        ...body,
      });

      setToastMessage("Datos bancarios actualizados correctamente");
      setToastVariant("success");
      setShowToast(true);
    } catch (error: any) {
      setToastMessage(error.message || "Error al guardar datos bancarios");
      setToastVariant("danger");
      setShowToast(true);
    }
  };

  return (
    <>
      <div className="bg-white p-4 rounded-3 mb-4 position-relative">
        <NavList />
        <CardBody>
          <Form onSubmit={onSubmit}>
            <Row>
              <Col lg={6} className="mb-3">
                <Form.Group>
                  <label>Tipo de cuenta</label>
                  <Form.Select
                    style={{ height: "50px" }}
                    value={accountType ?? ""}
                    isInvalid={isAccountTypeInvalid}
                    onChange={e => {
                      setAccountType(Number(e.target.value) as AccountType);
                      setBankId("");
                      setAccountNumber("");
                    }}
                  >
                    <option value="">Selecciona...</option>
                    {ACCOUNT_TYPES.map(t => (
                      <option key={t.id} value={t.id} disabled={t.disabled}>
                        {t.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Selecciona un tipo de cuenta
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="mb-3">
                <Form.Group>
                  <label>Banco</label>
                  <Form.Select
                    style={{ height: "50px" }}
                    value={bankId}
                    disabled={!accountType}
                    isInvalid={isBankInvalid}
                    onChange={e => {
                      setBankId(e.target.value);
                      setAccountNumber("");
                    }}
                  >
                    <option value="">Selecciona...</option>
                    {banks.map(b => (
                      <option key={b.id} value={b.id}>
                        {b.name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Selecciona un banco
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="mb-3">
                <Form.Group>
                  <label>
                    {isPhoneAccount ? "Número de celular" :accountType === 5 ?"Llave": "Número de cuenta"}
                  </label>
                  <Form.Control
                    type="text"
                    value={accountNumber}
                    disabled={!bankId}
                    isInvalid={isAccountNumberInvalid}
                    onChange={e => setAccountNumber(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {!accountNumber
                      ? "Este campo es obligatorio"
                      : "Solo puede contener números"}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="mb-3">
                <Form.Group>
                  <label>Nombre completo titular</label>
                  <Form.Control
                    type="text"
                    value={accountHolderName}
                    disabled={!bankId}
                    isInvalid={submitted && !accountHolderName}
                    onChange={e => setAccountHolderName(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Este campo es obligatorio
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="mb-3">
                <Form.Group>
                  <label>Tipo de identificación</label>
                  <Form.Select
                    style={{ height: "50px" }}
                    value={identificationType}
                    disabled={!bankId}
                    isInvalid={submitted && !identificationType}
                    onChange={e =>
                      setIdentificationType(e.target.value as IdentificationType)
                    }
                  >
                    <option value="">Selecciona...</option>
                    {IDENTIFICATION_TYPES.map(t => (
                      <option key={t.id} value={t.id}>
                        {t.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Este campo es obligatorio
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6} className="mb-3">
                <Form.Group>
                  <label>Número de identificación</label>
                  <Form.Control
                    type="text"
                    value={identificationNumber}
                    disabled={!bankId}
                    isInvalid={
                      submitted &&
                      (!identificationNumber || !onlyNumbers.test(identificationNumber))
                    }
                    onChange={e => setIdentificationNumber(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                  {!accountNumber
                    ? `${
                        isPhoneAccount
                          ? "Número de celular"
                          : accountType === 5
                          ? "Llave"
                          : "Número de cuenta"
                      } es obligatorio`
                    : `${
                        isPhoneAccount
                          ? "Número de celular"
                          : accountType === 5
                          ? "Llave"
                          : "Número de cuenta"
                      } solo puede contener números`}
                </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={12} className="mb-3">
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    id="accept-terms"
                    checked={acceptedTerms}
                    onChange={e => setAcceptedTerms(e.target.checked)}
                    isInvalid={submitted && !acceptedTerms}
                    label={
                      <>
                        Acepto los{" "}
                        <span
                          style={{
                            color: "#0d6efd",
                            cursor: "pointer",
                            textDecoration: "underline"
                          }}
                          onClick={() => setShowTermsModal(true)}
                        >
                          términos y condiciones
                        </span>
                      </>
                    }
                  />

                  {/* 👇 Mostrar error manualmente */}
                  {submitted && !acceptedTerms && (
                    <div className="text-danger mt-1">
                      Debes aceptar los términos y condiciones
                    </div>
                  )}
                </Form.Group>
              </Col>
                            <Col lg={12} className="d-flex justify-content-end mt-3">
                <Button type="submit" size="lg" disabled={isPending}>
                  {isPending ? "Guardando..." : "Guardar"}
                </Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </div>

      <Modal show={showTermsModal} onHide={() => setShowTermsModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Términos y Condiciones - Datos Bancarios</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Autorizo irrevocablemente a Multyhealt SAS, para que trasfiera, consigne o deposite, los dineros producto de mi relación comercial, con esta sociedad única y exclusivamente en esta cuenta que estoy registrando
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTermsModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}
